import React from 'react';

import cn from 'classnames';
import classNames from 'classnames';

import { SVG_IMAGES } from './images';
import css from './index.css';
import { SvgImageProps } from './props';
import { useUniqueUrls } from './use-unique-urls';

const SvgImage: React.FunctionComponent<SvgImageProps> = ({
    imageName,
    style,
    className,
    fill,
    noContainer,
    withUniqueUrls = true,
}) => {
    const svgHtml = useUniqueUrls(SVG_IMAGES[imageName], { needToModify: withUniqueUrls });

    return (
        <div
            className={cn(!noContainer ? css.Container : '', className)}
            dangerouslySetInnerHTML={{ __html: svgHtml }}
            style={{ color: fill, ...style }}
        />
    );
};

SvgImage.displayName = 'icon';

export default SvgImage;

export const iconProvider = (icon: React.ReactElement<SvgImageProps>) => (className?: string) => {
    return React.cloneElement(icon, { className: classNames(className, icon.props.className) });
};
